import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';

import { CreditCardIcon, ErrorIcon, MplButton } from '@mopla/ui';

interface IProps {
	handleOnClick: VoidFunction;
}

export const NoAccountsStep: FC<IProps> = ({ handleOnClick }) => {
	const { t } = useTranslation('openBanking');

	return (
		<>
			<Box display="flex" alignItems="center">
				<ErrorIcon />
				<Typography sx={{ ml: 1 }} variant="body2" color="error">
					{t('failed_validation')}
				</Typography>
			</Box>
			<MplButton
				testId="NoAccountsStep-AnotherMethodButton"
				variant="outlined"
				fullWidth
				onClick={() => handleOnClick()}
				startIcon={<CreditCardIcon />}
				sx={{ marginTop: '24px' }}
			>
				{t('button.another_method')}
			</MplButton>
		</>
	);
};
